import { APICore } from './apiCore'

const api = new APICore()

function getQuestionOpinometros (params) {
  const baseUrl = '/question-opinometro'
  return api.get(baseUrl, params)
}

function getQuestionOpinometro (id) {
  const baseUrl = `/question-opinometro/${id}`
  return api.get(baseUrl, {})
}

function addQuestionOpinometro (params) {
  const baseUrl = '/question-opinometro'
  return api.create(baseUrl, params)
}

function updateQuestionOpinometro (params) {
  const baseUrl = '/question-opinometro'
  return api.update(baseUrl, params)
}

function deleteQuestionOpinometro (params) {
  const baseUrl = '/question-opinometro'
  return api.delete(baseUrl, params)
}

export { getQuestionOpinometros, getQuestionOpinometro, addQuestionOpinometro, updateQuestionOpinometro, deleteQuestionOpinometro }
